import * as React from 'react';
import { Heading, Text, TextButton } from 'wix-style-react';
import ArrowRightSmall from 'wix-ui-icons-common/ArrowRightSmall';
import s from './PlansPageBottomBanner.scss';

export interface PlansPageBottomBannerProps {
  title: React.ReactNode;
  content: React.ReactNode;
  ctaText: React.ReactNode;
  cta(): void;
}

const PlansPageBottomBannerComp: React.FC<PlansPageBottomBannerProps> = ({
  content,
  cta,
  title,
  ctaText,
}) => {
  return (
    <div className={s.bannerContainer} data-hook='business-plans-banner'>
      <div className={s.innerBannerContainer}>
        <Heading
          weight='bold'
          dataHook='banner-title'
          className={s.bannerTitle}
        >
          {title}
        </Heading>
        <p className={s.bannerTextContainer}>
          <Text
            weight='normal'
            dataHook='banner-subtitle'
            className={s.bannerText}
          >
            {content}
          </Text>
        </p>
        <TextButton
          onClick={cta}
          dataHook='banner-textlink'
          className={s.bannerTextlink}
          suffixIcon={<ArrowRightSmall />}
        >
          {ctaText}
        </TextButton>
      </div>
    </div>
  );
};

export const PlansPageBottomBanner = PlansPageBottomBannerComp;
